import { useEffect, useState } from "react";
import { Link, Outlet, createFileRoute, useNavigate, useRouterState } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { FileText, FolderTree, Images, Trash2, ExternalLink, LogOut } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import logo from "@/assets/kk-logo.webp";

export const Route = createFileRoute("/_authenticated/admin")({
  head: () => ({ meta: [{ title: "CMS | Dr. Kelson Kawamura" }, { name: "robots", content: "noindex" }] }),
  component: AdminLayout,
});

const NAV: { to: string; label: string; icon: typeof FileText; exact?: boolean }[] = [
  { to: "/admin", label: "Artigos", icon: FileText, exact: true },
  { to: "/admin/categorias", label: "Categorias", icon: FolderTree },
  { to: "/admin/galeria", label: "Galeria", icon: Images },
  { to: "/admin/lixeira", label: "Lixeira", icon: Trash2 },
];

function AdminLayout() {
  const navigate = useNavigate();
  const path = useRouterState({ select: (s) => s.location.pathname });
  const [email, setEmail] = useState("");

  useEffect(() => {
    void supabase.auth.getUser().then(({ data }) => setEmail(data.user?.email ?? ""));
  }, []);

  async function signOut() {
    await supabase.auth.signOut();
    navigate({ to: "/auth" });
  }

  return (
    <div className="kk-cms">
      <aside className="kk-cms__side">
        <div className="kk-cms__brand">
          <img src={logo} alt="" />
          <span>CMS</span>
        </div>
        <nav className="kk-cms__nav">
          {NAV.map((item) => {
            const active = item.exact ? path === item.to : path.startsWith(item.to);
            return (
              <Link key={item.to} to={item.to} className={active ? "is-active" : ""}>
                <item.icon size={16} />
                {item.label}
              </Link>
            );
          })}
          <a href="/blog" target="_blank" rel="noopener noreferrer">
            <ExternalLink size={16} />
            Ver blog
          </a>
        </nav>
        <div className="kk-cms__side-foot">
          <span className="kk-cms__user">{email}</span>
          <button type="button" className="kk-cms__btn kk-cms__btn--ghost" onClick={signOut}>
            <LogOut size={15} /> Sair
          </button>
        </div>
      </aside>
      <main className="kk-cms__main">
        <Outlet />
      </main>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}
